export const APP_PWA_HOSTS = ['app.azkiservice.com', 'www.app.azkiservice.com'] as const;

export const PWA_APP_URL = 'https://app.azkiservice.com' as const;

export const PWA_APP_SCOPE = 'https://app.azkiservice.com/' as const;

export const PWA_UTM_SOURCE = 'PWAApp' as const;

export const PWA_APP_START_URL = `${PWA_APP_SCOPE}?utm_source=${PWA_UTM_SOURCE}` as const;
